import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'
import { FC, memo } from 'react'
import { TaskKindListToolbar } from './components/taskKindListToolbar/taskKindListToolbar'
import { TaskKindListGrid } from './components/taskKindListGrid/taskKindListGrid'

export const ProjectDetailManagementTaskKindList: FC = memo(() => {
  return (
    <div className="flex flex-col gap-2.5">
      <CrewErrorBoundary>
        <TaskKindListToolbar />
      </CrewErrorBoundary>

      <CrewErrorBoundary>
        <TaskKindListGrid />
      </CrewErrorBoundary>
    </div>
  )
})
